// extracted by mini-css-extract-plugin
export default {"toggle":"SMUgOBd_ZjcRjU8nEC96"};